import { render, staticRenderFns } from "./CopyExternalLink.vue?vue&type=template&id=50991210&scoped=true&"
import script from "./CopyExternalLink.vue?vue&type=script&lang=js&"
export * from "./CopyExternalLink.vue?vue&type=script&lang=js&"
import style0 from "./CopyExternalLink.vue?vue&type=style&index=0&id=50991210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50991210",
  null
  
)

export default component.exports